export default [
  {
    path: '/collectionPayment/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: 'setting',
        name: 'collectionPayment',
        component: () => import('@/views/CollectionPayment/Setting.vue'),
        meta: {
          prev: 'mainPage/collectionPayment_v2'
        }
      }
    ]
  }
]
